export const CUSTOMER_SURVEY_DISPLAY_DELAY_MS = 20000;

const STARTED_AT_KEY = 'customer_survey_login_delay_started_at';

const STALE_AFTER_MS = 12 * 60 * 60 * 1000;

function readStartedAt(): number | null {
  try {
    const raw = Number(localStorage.getItem(STARTED_AT_KEY));
    return Number.isFinite(raw) && raw > 0 ? raw : null;
  } catch {
    return null;
  }
}

function writeStartedAt(value: number): void {
  try {
    localStorage.setItem(STARTED_AT_KEY, String(value));
  } catch {
    return;
  }
}

export function remainingLoginDelayMs(delayMs: number, now: number = Date.now()): number {
  if (delayMs <= 0) return 0;

  const startedAt = readStartedAt();

  if (startedAt === null || now - startedAt > STALE_AFTER_MS || startedAt > now) {
    writeStartedAt(now);
    return delayMs;
  }

  return Math.max(0, delayMs - (now - startedAt));
}

export function clearLoginDelay(): void {
  try {
    localStorage.removeItem(STARTED_AT_KEY);
  } catch {
    return;
  }
}
